import React from 'react'
import { Loading, Message } from '@workwhile/ui'
import { parseErrorMessage } from 'api'
import { createContext } from 'lib/createContext'
import { useAssessmentTranscript } from 'queries/admin/coach/useAssessmentTranscript'

type TranscriptContextState = {
  state: {
    turns: NonNullable<ReturnType<typeof useAssessmentTranscript>['data']>
  }
  actions: Record<string, never>
}

const [TranscriptContext, useTranscriptContextValue] =
  createContext<TranscriptContextState>({
    name: 'AssessmentTranscriptContext',
  })

type TranscriptProviderProps = {
  transcriptUrl: string
  children: React.ReactNode
}

export const TranscriptProvider = ({
  transcriptUrl,
  children,
}: TranscriptProviderProps) => {
  const { data, isPending, isError, error } =
    useAssessmentTranscript(transcriptUrl)

  if (isPending) {
    return <Loading />
  }

  if (isError && !data) {
    return (
      <Message variant="error">
        {parseErrorMessage(error) ||
          'Failed to load transcript. Please try again.'}
      </Message>
    )
  }

  if (!data) {
    return null
  }

  return (
    <TranscriptContext.Provider value={{ state: { turns: data }, actions: {} }}>
      {children}
    </TranscriptContext.Provider>
  )
}

export { useTranscriptContextValue }
